export function isComponentMap(component) {
  return component !== null && typeof component === 'object' && !('$$typeof' in component) && Object.keys(component).length > 0;
}
//# sourceMappingURL=utils.js.map